__webpack_require__.p = "https://oyalopro.nagamills.com/";